import { Diccionario } from "./Diccionario";

export default class Utilidades {
    
    public static FormatearANumero(numero: string): string {
        let valor: number = Number(numero);
        let number = Math.round(valor*100)/100;
        let final = number.toLocaleString('en-US');
        final = final.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        let idx = final.indexOf('.');
        if (idx === -1) {
            final += '.00';
        } else {
            final = final.substring(0,idx) + final.substring(idx).padEnd(3,'0');
        }

        return final;
    }

    public static getStringOfDate(dateNew: Date): string {
        return dateNew.getDate().toString() + ' de ' + this.strMonths(dateNew.getMonth()) + ' de ' + dateNew.getFullYear().toString();
    }

    public static getStringOfDateShort(dateNew: Date): string {
        return dateNew.getDate().toString().padStart(2,'0') + '/' + (dateNew.getMonth()+1).toString().padStart(2,'0') + '/' + dateNew.getFullYear().toString();
    }

    public static getStringOfDateStandard(dateNew: Date): string {
        return dateNew.getFullYear().toString() +  (dateNew.getMonth()+1).toString().padStart(2,'0') + dateNew.getDate().toString().padStart(2,'0');
    }

    public static strMonths(idMonth: number): string {
        let diccionario: Diccionario = new Diccionario();
    
        diccionario.add('0', 'enero');
        diccionario.add('1', 'febrero');
        diccionario.add('2', 'marzo');
        diccionario.add('3', 'abril');
        diccionario.add('4', 'mayo');
        diccionario.add('5', 'junio');
        diccionario.add('6', 'julio');
        diccionario.add('7', 'agosto');
        diccionario.add('8', 'septiembre');
        diccionario.add('9', 'octubre');
        diccionario.add('10', 'noviembre');
        diccionario.add('11', 'diciembre');
    
        return diccionario.get(idMonth.toString());
    }

    public static stringToNumber(numero: string): number {
        let amountValue: string = numero.replace(/,/g,'');

        if (Number.isNaN(amountValue) ) {
            return 0;
        }

        return Number(amountValue);
    }    
}